var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { isEqual } from "lodash-es";
import { Component, Vue, Inject, Watch, Prop } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
let CompPathHistory = class CompPathHistory extends Vue {
  constructor() {
    super(...arguments);
    this.isRetrieving = false; // 从记录中恢复到选中的旧组件时，不要触发记录
    this.stack = {};
    this.stackIndex = {}; // 前进回退时使用的索引
    this.highlightedElement = [];
  }
  onScopeStackChange() {
    this.recordScope();
  }
  onCompPathChange() {
    this.recordScope();
  }
  get pageId() {
    return this.designer.pageletId;
  }
  get currentStack() {
    return this.stack[this.pageId] || [];
  }
  get currentStackIndex() {
    return this.stackIndex[this.pageId] || 0;
  }
  get MaximumStackLength() {
    return this.designer.compPathHistoryMaxNum;
  }
  created() {
    this.recordScope();
  }
  getNameByCompPath(compPath, index = 0) {
    const layout = this.designer.getLayoutAtPath(compPath);
    return this.designer.uc.getLayoutName(layout, {
      omitId: this.designer.skeletonStyle.UcdToolbarBreadCrumbHideCompId
    }) || `组件#${index}` || '未知组件';
  }
  getPathName() {
    const {
      paths
    } = this;
    const pathNames = paths.map((path, index) => this.getNameByCompPath(path, index));
    return pathNames.join(' / ');
  }
  recordScope() {
    if (this.isRetrieving) return;
    const currentStack = this.stack[this.pageId] || [];
    const lastScope = currentStack[0];
    if (lastScope) {
      if (isEqual(lastScope.sourcePath, this.designer.sourcePath) && lastScope.compPath === this.designer.compPath) {
        return;
      }
    }
    currentStack.unshift({
      sourcePath: this.designer.sourcePath,
      compPath: this.designer.compPath,
      path: this.getPathName(),
      scopeStack: [...this.designer.scopeStack]
    });
    this.$set(this.stack, this.pageId, currentStack.slice(0, this.MaximumStackLength));
    this.$set(this.stackIndex, this.pageId, 0);
  }
  async jumpToScope(scope) {
    this.isRetrieving = true;
    await this.designer.setSourcePath(scope.sourcePath);
    this.designer.compPath = scope.compPath;
    this.$nextTick(() => {
      this.isRetrieving = false;
    });
  }
  async forward() {
    if (this.currentStackIndex === this.currentStack.length - 1) return;
    this.stackIndex[this.pageId] = this.currentStackIndex + 1;
    const scope = this.currentStack[this.currentStackIndex];
    await this.jumpToScope(scope);
  }
  async backward() {
    if (this.currentStackIndex === 0) return;
    this.stackIndex[this.pageId] = this.currentStackIndex - 1;
    const scope = this.currentStack[this.currentStackIndex];
    await this.jumpToScope(scope);
  }
  highlightSelectPath(scope) {
    var _scope$scopeStack;
    const renderer = ((_scope$scopeStack = scope.scopeStack[scope.scopeStack.length - 1]) === null || _scope$scopeStack === void 0 ? void 0 : _scope$scopeStack.renderer) || this.designer.renderer;
    const instance = renderer === null || renderer === void 0 ? void 0 : renderer.getRefByPath(scope.compPath);
    if (!instance) return;
    instance.$el.classList.add('ucd-compPathHistory-highlight');
  }
  removeHighlight(scope) {
    var _scope$scopeStack2;
    const renderer = ((_scope$scopeStack2 = scope.scopeStack[scope.scopeStack.length - 1]) === null || _scope$scopeStack2 === void 0 ? void 0 : _scope$scopeStack2.renderer) || this.designer.renderer;
    const instance = renderer === null || renderer === void 0 ? void 0 : renderer.getRefByPath(scope.compPath);
    if (!instance) return;
    instance.$el.classList.remove('ucd-compPathHistory-highlight');
  }
  render() {
    const h = arguments[0];
    if (this.currentStack.length <= 1) return null;
    return h("div", {
      "class": 'ucd-compPathHistory'
    }, [h("a-icon", {
      "class": 'ucd-compPathHistory-icon',
      "on": {
        "click": this.forward
      },
      "attrs": {
        "type": "caret-left"
      }
    }), h("a-icon", {
      "class": 'ucd-compPathHistory-icon',
      "on": {
        "click": this.backward
      },
      "attrs": {
        "type": "caret-right"
      }
    }), h("a-tooltip", {
      "attrs": {
        "placement": "bottom"
      }
    }, [h("div", {
      "slot": 'title'
    }, [this.currentStack.map(item => h("div", {
      "class": 'ucd-compPathHistory-item',
      "on": {
        "mouseenter": () => {
          this.highlightSelectPath(item);
        },
        "mouseleave": () => {
          this.removeHighlight(item);
        },
        "click": () => {
          this.jumpToScope(item);
        }
      }
    }, [item.path]))]), h("a-icon", {
      "class": 'ucd-compPathHistory-icon',
      "attrs": {
        "type": 'history'
      }
    })])]);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], CompPathHistory.prototype, "designer", void 0);
__decorate([Watch('designer.scopeStack')], CompPathHistory.prototype, "onScopeStackChange", null);
__decorate([Watch('designer.compPath')], CompPathHistory.prototype, "onCompPathChange", null);
__decorate([Prop(Array)], CompPathHistory.prototype, "paths", void 0);
CompPathHistory = __decorate([Component({
  name: 'CompPathHistory'
})], CompPathHistory);
export { CompPathHistory };
export default CompPathHistory;
//# sourceMappingURL=CompPathHistory.js.map
